// @flow
import React from 'react'
import Button from 'reactstrap/lib/Button'

type AddRemoveArrayTypeComponentProps = {
  fieldName: string,
  onAddClick: (fieldName: string, prefix: string) => void,
  onRemoveClick: (fieldName: string, prefix: string) => void,
  prefix: string,
}

export default class AddRemoveArrayTypeComponent extends React.Component<AddRemoveArrayTypeComponentProps> {
  handleAddNewItemToArrayType = () => {
    this.props.onAddClick(this.props.fieldName, this.props.prefix)
  }

  handleRemoveItemFromArrayType = () => {
    this.props.onRemoveClick(this.props.fieldName, this.props.prefix)
  }

  render() {
    return (
      <div className='row'>
        <div className='col-2 offset-4'>
          <Button
            block
            color='default'
            onClick={this.handleAddNewItemToArrayType}
            outline
          >+</Button>
        </div>
        <div className='col-2'>
          <Button
            block
            color='default'
            onClick={this.handleRemoveItemFromArrayType}
            outline
          >-</Button>
        </div>
      </div>
    )
  }
}
